import { ConnectionAuthInfo } from '../../../connectivity/serverApi/types/connection/IConnectionAuthInfo';
import { UnencryptedConnectionKeychain } from '../../../connectivity/serverApi/types/connection/IConnectionKeyChain';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IRevertWorkbookParams {
  id: string;
  version: number;
  keychains?: UnencryptedConnectionKeychain[];
  encryptedPasswordKeyId?: string;
}

export interface IRevertWorkbookResult extends IResult {
  failedConnection?: ConnectionAuthInfo;
  scheduledExtractCredentialsMayNotBeRestored?: boolean;
}

export class RevertWorkbookRequest extends Request<IRevertWorkbookParams, IRevertWorkbookResult> {
  constructor(params: IRevertWorkbookParams) {
    super('revertWorkbook', params);
  }
}
